import React, { useEffect } from 'react';

export const LoadingProgress = (props: { children: React.ReactNode; loading: boolean }) => {
    useEffect(() => {
        if (props.loading) {
            WhistleOut.startProgress('#loading-container', 0.1, 50);
        } else {
            WhistleOut.endProgress('#loading-container');
        }
    }, [props.loading]);

    return (
        <React.StrictMode>
            <div id="loading-container">{props.children}</div>
        </React.StrictMode>
    );
};
